import React from 'react';
import popularSpaceBadge from '../../assets/images/search-result/popularSpaceBadge.svg';

function Spacecard({ visibleMap, setImageQuality, space, IMAGES_BASE_URL, personWhite, locationWhite }) {
  // Build the content title from available parts
  const toTitleCase = (str) =>
    typeof str === 'string'
      ? str
          .toLowerCase()
          .replace(/\b\w+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1))
      : str;

  const titleParts = [
    toTitleCase(space?.eventType?.toString?.()),
    space?.category,
    space?.address,
  ].filter(Boolean);

  const title = titleParts.join(' ');

  const truncate = (str, len = 40) =>
    typeof str === 'string' && str.length > len ? `${str.substring(0, len)}...` : str;

  return (
    <>
      <div
        className="search-result-thumbnail"
        style={{ backgroundImage: `url(${IMAGES_BASE_URL + setImageQuality() + space?.image})` }}
      >
        {/* Top-left content title overlay */}
        {title && (
          <div className="content-title-overlay">
            <span className="content-title" title={title}>
              {truncate(title)}
            </span>
          </div>
        )}

        <div className="popular-picks-icon">
          <div>
            {space?.popularPicks ? (
              <img src={popularSpaceBadge} className="img" alt="icon" />
            ) : (
              ''
            )}
            <div className="tooltip-wrapper">This is a popular space</div>
          </div>
        </div>
        <div className="number-of-people">
          <img src={personWhite} className="img" alt="person" />
          <span className="people">{space?.capacity}</span>
        </div>
      </div>
    </>
  );
}

export default React.memo(Spacecard);
